import request from '@/utils/request';
export function customerFsSelect(params) {
  return request({
    url: '/orders/customer/fs-select',
    method: 'get',
    params: params
  });
}
export function getCustomerTypeList(params) {
  return request({
    url: '/user/customer/get-customer-type-list',
    method: 'get',
    params: params
  });
}

// 获取单一，公海查询日志,获取批量查询日志
export function getAllLogList(data) {
  return request({
    url: '/orders/general-log/list',
    method: 'post',
    data: data
  });
}
// 查看导入详情
export function getImportDetails(data) {
  return request({
    url: '/orders/general-log/export-list',
    method: 'post',
    data: data
  });
}
// 二维码解码
export function decode(data) {
  return request({
    url: '/sales/tools/decode',
    method: 'post',
    data: data
  });
}
// 获取交付方式
export function getSeasList(params) {
  return request({
    url: '/user/customer/open-sea',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 二维码提示文字
export function getInvoiceTips(params) {
  return request({
    url: '/products/page-description/get-invoice-tips-no-auth',
    method: 'get',
    params: params
  });
}
// 领取客户
export function claimCustomer(params) {
  return request({
    url: '/user/customer/get-customer',
    method: 'get',
    params: params
  });
}
// 领取客户信息
export function getClaimCustomer(params) {
  return request({
    url: '/user/customer/get-customer-info',
    method: 'get',
    params: params
  });
}
// 领取客户
export function customerCheckRepeat(params) {
  return request({
    url: '/user/customer/check-repeat',
    method: 'get',
    params: params
  });
}
// 获取省市区数据
export function getCity(data) {
  return request({
    url: '/user/customer/city',
    method: 'post',
    data: data
  });
}
export function jumpOpensea(data) {
  return request({
    url: '/user/customer/jump-opensea',
    method: 'post',
    data: data
  });
}
// 提交仲裁
export function applyArbitration(data) {
  return request({
    url: '/user/customer/apply-arbitration',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 领取/划转审核列表
export function auditCustomerList(data) {
  return request({
    url: '/user/customer/audit-customer',
    method: 'post',
    data: data
  });
}
// 提交仲裁
export function subAudit(data) {
  return request({
    url: '/user/customer/audit',
    method: 'post',
    data: data
  });
}
// 获取审核详情
export function getAuditInfo(data) {
  return request({
    url: '/user/customer/audit-info',
    method: 'post',
    data: data
  });
}
// 修改审核人
export function upAuditUser(data) {
  return request({
    url: '/user/customer/up-audit',
    method: 'post',
    data: data
  });
}

// 我的商城账号列表
export function getShopAccount(params) {
  return request({
    url: '/user/shop-account/index',
    method: 'get',
    params: params
  });
}

// 更改账号状态
export function changeUserStataus(data) {
  return request({
    url: '/user/shop-account/change-user-status',
    method: 'post',
    data: data
  });
}

// 清除用户登录状态
export function clearLoginStatus(params) {
  return request({
    url: '/user/shop-account/sign-out',
    method: 'get',
    params: params
  });
}

// 获取用户登录信息
export function getWechatInformation(params) {
  return request({
    url: '/user/shop-account/get-wechat-information',
    method: 'get',
    params: params
  });
}

// 设置默认账号
export function setDefaultAccount(data) {
  return request({
    url: '/user/shop-account/set-default-account',
    method: 'post',
    data: data
  });
}

// 获取用户公司列表
export function getAccountList(params) {
  return request({
    url: '/user/shop-account/get-account',
    method: 'get',
    params: params
  });
}

//获取日志
export function getShopUserLog(params) {
  return request({
    url: '/user/shop-account/get-log',
    method: 'get',
    params: params
  });
}

//获取日志类型
export function getShopUserLogType(params) {
  return request({
    url: '/user/shop-account/get-type',
    method: 'get',
    params: params
  });
}
// 解码操作日志
export function getCodeLog(params) {
  return request({
    url: '/sales/tools/get-code-log',
    method: 'get',
    params: params
  });
}
// 获取当前登录人贡献点
export function getCustomerPoint(data) {
  return request({
    url: '/user/customer/get-customer-point',
    method: 'post',
    data: data
  });
}
// 单一查重退回
export function returnCustomer(data) {
  return request({
    url: '/user/customer/return',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 联系人系统存不存在
export function getArbitrationContact(data) {
  return request({
    url: '/user/customer/get-arbitration-contact',
    method: 'post',
    data: data
  });
}
// 我发起的列表
export function getInitiatedByMe(data) {
  return request({
    url: '/user/project-delivery/initiated-by-me',
    method: 'post',
    data: data
  });
}

// 我待办的列表
export function getMyToDoList(data) {
  return request({
    url: '/user/project-delivery/my-to-do',
    method: 'post',
    data: data
  });
}

// 审核列表
export function getMyReviewList(data) {
  return request({
    url: '/user/project-delivery/my-review',
    method: 'post',
    data: data
  });
}

// 创建申请
export function createProjectDelivery(data) {
  return request({
    url: '/user/project-delivery/create-project-delivery',
    method: 'post',
    data: data
  });
}

// 申请详情
export function getProjectDeliveryDetail(params) {
  return request({
    url: '/user/project-delivery/view',
    method: 'get',
    params: params
  });
}

// 再次申请
export function launchedAgain(data) {
  return request({
    url: '/user/project-delivery/launched-again',
    method: 'post',
    data: data
  });
}

// 审核
export function auditProjectDelivery(data) {
  return request({
    url: '/user/project-delivery/audit',
    method: 'post',
    data: data
  });
}

// 日志列表
export function getProjectDeliveryLog(params) {
  return request({
    url: '/user/project-delivery/log',
    method: 'get',
    params: params
  });
}

// 查询处理结果
export function getProjectDeliveryHandleType(params) {
  return request({
    url: '/user/project-delivery/get-handle-type',
    method: 'get',
    params: params
  });
}

//提交处理结果
export function submitProjectDeliveryHandle(data) {
  return request({
    url: '/user/project-delivery/handle',
    method: 'post',
    data: data
  });
}

//验收
export function submitProjectDeliveryAcceptance(data) {
  return request({
    url: '/user/project-delivery/acceptance',
    method: 'post',
    data: data
  });
}